// Environmental Initiatives page Indonesian translations

export default {
  pageTitle: "Inisiatif Lingkungan",
  breadcrumbHome: "Beranda",
  breadcrumbSustainability: "Keberlanjutan",
  breadcrumbCurrent: "Inisiatif Lingkungan",
  title: "Inisiatif Lingkungan",
  sustainability: "Keberlanjutan",
  conceptOfSustainability: "Konsep Keberlanjutan",
  environmentalInitiatives: "Inisiatif Lingkungan",
  occupationalHealthSafety: "Kesehatan & Keselamatan Kerja",
  socialContributionInitiatives: "Inisiatif Kontribusi Sosial",
  
  // Environmental Initiatives Details Section
  environmentalInitiativesTitle: "Inisiatif Lingkungan di P.T.  Eagle Industry Indonesia",
  environmentalInitiativesDesc1: "P.T.  Eagle Industry Indonesia beroperasi dalam manufaktur segel untuk komponen otomotif dengan proses utama Casting dan O-ring yang berfungsi sebagai penahan pelumas dengan lingkungan eksternal seperti air, lumpur, atau debu di area under carrier mesin konstruksi, alat berat, atau mesin pertanian.",
  environmentalInitiativesDesc2: "Dengan teknologi presisi dan kualitas tinggi, produk kami membantu meningkatkan keandalan mesin sambil mendukung pengurangan dampak lingkungan, karena mereka berperan dalam mencegah polusi dari kebocoran oli atau fluida ke tanah.",
  
  // Environmental Management System Section
  environmentalManagementSystemTitle: "Sistem Manajemen Lingkungan",
  environmentalManagementSystemDesc: "Sebagai bagian dari Grup EKK, P.T.  Eagle Industry Indonesia secara konsisten melakukan kegiatan pelestarian lingkungan. Perusahaan telah tersertifikasi ISO 14001:2015 sebagai bukti implementasi sistem manajemen lingkungan yang distandarkan secara internasional.",
  
  // Environmental Policy Section
  environmentalPolicyTitle: "Kebijakan Lingkungan",
  environmentalPolicyDesc: "P.T.  Eagle Industry Indonesia mengakui dan peduli terhadap lingkungan. Berkomitmen untuk melindungi lingkungan dan mencegah polusi serta pemanasan global, dengan menghemat energi dan menggunakan sumber daya, serta memanfaatkan energi terbarukan.",
  
  // Environmental Activities Section
  environmentalActivitiesTitle: "Aktivitas Lingkungan",
  solarPanelGenerationTitle: "Generasi Panel Surya",
  solarPanelGenerationDesc: "P.T.  Eagle Industry Indonesia mulai memanfaatkan pembangkit tenaga surya sejak awal 2025, sebagai bagian dari upaya mengurangi emisi CO2.",
  
  // Environmental Awards and Certifications Section
  environmentalAwardsTitle: "Penghargaan dan Sertifikasi Lingkungan",
  environmentalAwardsDesc: "P.T.  Eagle Industry Indonesia mengimplementasikan Sistem Manajemen Lingkungan ISO 14001:2015. Kemudian menerima peringkat PROPER Biru dari Kementerian Lingkungan Hidup dan Kehutanan Republik Indonesia, sebagai pengakuan untuk kepatuhan terhadap peraturan lingkungan di Indonesia.",
  
  // Environmental & Safety Certifications Section
  environmentalSafetyCertificationsTitle: "Sertifikasi Lingkungan & Keselamatan",
  environmentalSafetyCertificationsDesc: "Komitmen kami terhadap manajemen lingkungan dan standar kesehatan & keselamatan kerja",
  
  // Certification Table
  certificationTable: {
    certification: "Sertifikasi",
    standard: "Standar",
    description: "Deskripsi",
    qualityManagementSystem: "Sistem Manajemen Kualitas",
    qualityManagementSystemDesc: "Standar internasional untuk sistem manajemen kualitas yang menunjukkan kemampuan kami untuk secara konsisten menyediakan produk dan layanan yang memenuhi persyaratan pelanggan dan peraturan sambil meningkatkan kepuasan pelanggan",
    environmentalManagementSystem: "Sistem Manajemen Lingkungan",
    environmentalManagementSystemDesc: "Standar internasional untuk sistem manajemen lingkungan yang membantu organisasi meminimalkan dampak lingkungan mereka sambil mematuhi peraturan",
    occupationalHealthSafety: "Manajemen Kesehatan & Keselamatan Kerja",
    occupationalHealthSafetyDesc: "Standar internasional untuk sistem manajemen kesehatan dan keselamatan kerja yang menyediakan kerangka kerja untuk meningkatkan keselamatan karyawan, mengurangi risiko tempat kerja, dan menciptakan kondisi kerja yang lebih baik",
    environmentalCompliance: "Kepatuhan Lingkungan",
    environmentalComplianceDesc: "Pengakuan dari Kementerian Lingkungan Hidup dan Kehutanan Republik Indonesia untuk kepatuhan terhadap peraturan lingkungan dalam operasi industri",
    noteText: "Catatan: Sertifikasi ini menunjukkan komitmen kami terhadap pelestarian lingkungan, kesehatan & keselamatan kerja, dan praktik berkelanjutan."
  },
  
  // Certification Evidence Section
  certificationEvidenceTitle: "Bukti Sertifikasi",
  certificationEvidenceDesc: "Lihat sertifikasi lingkungan dan dokumen kepatuhan kami",
  issuer: "Penerbit",
  issueDate: "Tanggal Terbit",
  expiryDate: "Tanggal Kedaluwarsa",
  viewCertificate: "Lihat Sertifikat",
  
  // Related Topics Section
  relatedTopicsTitle: "Topik Keberlanjutan Terkait",
  relatedTopicsDesc: "Jelajahi lebih lanjut tentang inisiatif keberlanjutan kami",
  conceptOfSustainabilityCard: "Konsep Keberlanjutan",
  socialContributionInitiativesCard: "Inisiatif Kontribusi Sosial",
  occupationalHealthSafetyCard: "Kesehatan & Keselamatan Kerja"
};